import { useEffect } from 'react';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import { Button } from '@zep-us/zus';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ZDialog } from '@/ui';
const {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogPanel,
  DialogFooter
} = ZDialog;
const DisabledEditAlertModalComponent = (props: {
  type: 'unknown' | 'plan';
  recoveryReasons?: Array<'map' | 'match' | 'order'>;
  onEdit?: () => void;
}) => {
  const {
    visible,
    remove
  } = useModal();
  const router = useRouter();
  const {
    t
  } = useTranslation(['build', 'common']);
  const recoveryReasons = props.recoveryReasons ?? ['map'];
  const showMapRecovery = props.type === 'plan' && recoveryReasons.includes('map');
  const showMatchRecovery = props.type === 'plan' && recoveryReasons.includes('match');
  const showOrderRecovery = props.type === 'plan' && recoveryReasons.includes('order');
  const handleEdit = () => {
    remove();
    setTimeout(() => props.onEdit?.(), 0);
  };
  useEffect(() => {
    router.events.on('routeChangeStart', () => {
      remove();
    });
    return () => {
      router.events.off('routeChangeStart', () => {
        remove();
      });
    };
  }, [remove, router.events]);
  return <Dialog maxWidth={'320px'} open={visible} onClose={() => {
    remove();
  }} data-sentry-element="Dialog" data-sentry-component="DisabledEditAlertModalComponent" data-sentry-source-file="DisabledEditAlertModal.tsx">
      <DialogPanel data-sentry-element="DialogPanel" data-sentry-source-file="DisabledEditAlertModal.tsx">
        <DialogHeader data-sentry-element="DialogHeader" data-sentry-source-file="DisabledEditAlertModal.tsx">
          <DialogTitle className={''} data-sentry-element="DialogTitle" data-sentry-source-file="DisabledEditAlertModal.tsx">
            {props.type === 'plan' ? t('build:build.guide.disabledQuizEdit') : t('build:build.lockRecovery.editorUnavailableTooltip')}
          </DialogTitle>
        </DialogHeader>
        <DialogContent data-sentry-element="DialogContent" data-sentry-source-file="DisabledEditAlertModal.tsx">
          {props.type === 'plan' ? <div className={'text-body-md font-medium'}>
              <ul className={'list-disc pl-md'}>
                {showMapRecovery && <li>
                    {t('build:build.lockRecovery.availableFreeMapAction')}
                  </li>}
                {showMatchRecovery && <li>
                    {t('common:quizCard.typeBadge.match')} -{' '}
                    {t('common:global.delete')}
                  </li>}
                {showOrderRecovery && <li>
                    {t('common:quizCard.typeBadge.order')} -{' '}
                    {t('common:global.delete')}
                  </li>}
              </ul>
            </div> : <div className={'whitespace-pre-line text-body-md font-medium'}>
              {t('build.autoSave.sorryMessage')}
            </div>}
        </DialogContent>
        <DialogFooter className={'w-full'} data-sentry-element="DialogFooter" data-sentry-source-file="DisabledEditAlertModal.tsx">
          <div className={'flex w-full flex-col gap-xs'}>
            {props.type === 'plan' && <Button onClick={() => {
            void router.replace('/pricing');
          }}>
                {t('build:build.guide.proPlanUpgrade')}
              </Button>}
            <Button intent={'alternative'} onClick={props.type === 'plan' ? handleEdit : () => remove()} data-sentry-element="Button" data-sentry-source-file="DisabledEditAlertModal.tsx">
              {props.type === 'plan' ? t('common:quizListItem.moreBtn.edit') : t('common:global.close.button')}
            </Button>
          </div>
        </DialogFooter>
      </DialogPanel>
    </Dialog>;
};
export const DisabledEditAlertModal = NiceModal.create(DisabledEditAlertModalComponent);